import React from 'react';
import styled from 'styled-components';

import {getColor} from '../../lib/color';
import Button from '../Button';
import {T} from '../I18n';

import Group from './Group';

function Avatar(props) {
  const {id, user, size = '2.5rem', onClick, to} = props;
  
  if (onClick || to) {
    return <ButtonWithPadding blank onClick={onClick} to={to}><Avatar {...props} onClick={null} to={null} /></ButtonWithPadding>;
  }

  return (
    <T element={Container} noTranslate id={id} size={size} image={user.photo} title={user.userName}>
      {!user.photo && (
        <Letter size={size} color={getColor(user.id)}>{user.userName[0].toUpperCase()}</Letter>
      )}
    </T>
  );
}

const ButtonWithPadding = styled(Button)`
  padding: 0.4575rem; // This value matches the size of the largest axis of the box-shadow.
  margin: -0.4575rem;
`;

const Container = styled.div`
  border: 0.125rem solid #FFF;
  border-radius: 50%;
  overflow: hidden;
  width: ${props => props.size};
  height: ${props => props.size};
  background-image: ${props => props.image && `url(${props.image})`};
  background-size: cover;
  box-shadow: 0 0.1875rem 0.4575rem rgba(90, 97, 105, 0.5);
`;

const Letter = styled.div`
  background: ${props => props.color};
  color: #FFF;
  height: ${props => props.size};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${props => Math.min(parseInt(props.size.replace('rem', '')) / 2, 3)}rem;
  margin-top: -2px;
`;

Avatar.Group = Group;
export default Avatar;